export default "__VITE_ASSET__BccESkJY__"